import {
  ConvertableAsset,
  ConvertError
} from '@/api/resources/arcade/convert/schema'
import Button from '@/components/Button'
import { showModal } from '@/components/Modals/ModalV2'
import Toast from '@/components/Toast'
import { MODAL_ID } from '@/constants/modalId'
import { NonTransferableCategoryProps } from '@/features/transfer/modals/NonTransferableAssetsModal'
import { pluralize } from '@/util/stringHelpers'

interface Props {
  errors: ConvertError[]
  listings: ConvertableAsset[]
}

const WarningAndErrors = ({ errors, listings }: Props) => {
  const hasListings = listings?.length > 0
  const hasErrors = errors?.length > 0
  if (!hasErrors && !hasListings) return null

  return (
    <div className="space-y-2">
      {hasListings && (
        <WarningInlineToast
          categories={[
            {
              type: 'LISTED',
              description:
                'These items are currently listed on the Droppp Marketplace. If you choose to convert them, they will be delisted before conversion.',
              assets: listings
            }
          ]}
        />
      )}
      {hasErrors && (
        <WarningInlineToast
          title="Non Convertable Items"
          description="won't convert"
          categories={errors.map(error => {
            return {
              ...error,
              assets: error.assets
            }
          })}
        />
      )}
    </div>
  )
}

interface WarningProps {
  className?: string
  title?: string
  description?: string
  categories: NonTransferableCategoryProps[]
}

const WarningInlineToast = ({
  className,
  categories,
  description = 'will be delisted',
  title = 'Items to be delisted'
}: WarningProps) => {
  const count = categories.reduce(
    (acc, category) => acc + category.assets.length,
    0
  )

  return (
    <Toast inline type="attention" className={className}>
      <Button
        theme="clean"
        className="w-full flex flex-wrap gap-1 justify-between items-center"
        onClick={() =>
          showModal(MODAL_ID.transfer.nonTransferableAssets, {
            title,
            categories
          })
        }
      >
        {count} {pluralize('Item', count)} {description}.
        <span className="utility uppercase">Review</span>
      </Button>
    </Toast>
  )
}

export default WarningAndErrors
